import { UpdatesItem } from '@platform-lib/updates/updates.model'
import dayjs from 'dayjs'

export const sortUpdates = (updates: UpdatesItem[]) =>
    updates.sort((a, b) =>
        dayjs(a.createdAt).isBefore(dayjs(b.createdAt)) ? 1 : -1
    )
